import { AccordionTitle as AccordionTitle$1, AccordionContent as AccordionContent$1, Accordion as Accordion$1, Badge as Badge$1, BannerActionPrimary as BannerActionPrimary$1, BannerActions as BannerActions$1, BannerActionSecondary as BannerActionSecondary$1, BannerDescription as BannerDescription$1, BannerIcon as BannerIcon$1, BannerTitle as BannerTitle$1, Banner as Banner$1, Button as Button$1, CardTitle as CardTitle$1, CardSubtitle as CardSubtitle$1, CardBody as CardBody$1, CardDivider as CardDivider$1, CardActionPrimary as CardActionPrimary$1, CardActionSecondary as CardActionSecondary$1, CardActionTertiary as CardActionTertiary$1, CardFooter as CardFooter$1, Card as Card$1, Checkbox as Checkbox$1, DialogActionPrimary as DialogActionPrimary$1, DialogActionSecondary as DialogActionSecondary$1, DialogActionTertiary as DialogActionTertiary$1, DialogActions as DialogActions$1, DialogBody as DialogBody$1, DialogClose as DialogClose$1, DialogFooter as DialogFooter$1, DialogHeader as DialogHeader$1, Dialog as Dialog$1, Divider as Divider$1, DrawerActionPrimary as DrawerActionPrimary$1, DrawerActionSecondary as DrawerActionSecondary$1, DrawerActionTertiary as DrawerActionTertiary$1, DrawerActions as DrawerActions$1, DrawerBody as DrawerBody$1, DrawerClose as DrawerClose$1, DrawerHeader as DrawerHeader$1, Drawer as Drawer$1, DropdownItem as DropdownItem$1, DropdownMenu as DropdownMenu$1, DropdownTrigger as DropdownTrigger$1, Dropdown as Dropdown$1, EmptyStateIllustration as EmptyStateIllustration$1, EmptyStateHeader as EmptyStateHeader$1, EmptyStateMessage as EmptyStateMessage$1, EmptyStateAction as EmptyStateAction$1, EmptyState as EmptyState$1, FieldLabel as FieldLabel$1, FieldHint as FieldHint$1, Field as Field$1, HeaderActions as HeaderActions$1, HeaderContent as HeaderContent$1, HeaderTitle as HeaderTitle$1, SubHeader as SubHeader$1, BackButton, Header as Header$1, Icon as Icon$1, LabeledValueLabel as LabeledValueLabel$1, LabeledValueValue as LabeledValueValue$1, LabeledValue as LabeledValue$1, Box as Box$1, Group as Group$1, Stack as Stack$1, Grid as Grid$1, Sidebar as Sidebar$1, Switcher as Switcher$1, Container as Container$1, Row as Row$1, Column as Column$1, Link as Link$1, Body as Body$1, PageContent as PageContent$1, Pagination as Pagination$1, ProgressBar as ProgressBar$1, ProgressBarCountdown as ProgressBarCountdown$1, RadioGroup as RadioGroup$1, Radio as Radio$1, SectionTitle as SectionTitle$1, Section as Section$1, SpinnerWheel as SpinnerWheel$1, Step as Step$1, Steps as Steps$1, Switch as Switch$1, TableHead as TableHead$1, TableBody as TableBody$1, TableFoot as TableFoot$1, TableRow as TableRow$1, TableCell as TableCell$1, TableToolbar as TableToolbar$1, TableHeadCell as TableHeadCell$1, TableFeedback as TableFeedback$1, TableActions as TableActions$1, Table as Table$1, Tab as Tab$1, TabPanel as TabPanel$1, Tabs as Tabs$1, Tag as Tag$1, ActionableTag as ActionableTag$1, Text as Text$1, TextArea as TextArea$1, TextField as TextField$1, TimelineItem as TimelineItem$1, TimelineExpandableItem as TimelineExpandableItem$1, TimelineItemBody as TimelineItemBody$1, TimelineItemFooter as TimelineItemFooter$1, TimelineItemHeader as TimelineItemHeader$1, TimelineItemHeaderSubtitle as TimelineItemHeaderSubtitle$1, TimelineItemHeaderTitle as TimelineItemHeaderTitle$1, TimelineItemIcon as TimelineItemIcon$1, Timeline as Timeline$1, Toggle as Toggle$1, ToggleGroup as ToggleGroup$1, Tooltip as Tooltip$1, LogoLoader as LogoLoader$1, DotsLoader as DotsLoader$1 } from '@loadsmart/miranda-wc';
export { DIALOG_SIZES, DIALOG_VARIANTS, DRAWER_SIZES, EMPTY_STATE_VARIANTS, Accordion as WCAccordion, AccordionContent as WCAccordionContent, AccordionTitle as WCAccordionTitle, ActionableTag as WCActionableTag, Badge as WCBadge, Banner as WCBanner, BannerActionPrimary as WCBannerActionPrimary, BannerActionSecondary as WCBannerActionSecondary, BannerActions as WCBannerActions, BannerDescription as WCBannerDescription, BannerIcon as WCBannerIcon, BannerTitle as WCBannerTitle, Box as WCBox, Button as WCButton, Card as WCCard, CardActionPrimary as WCCardActionPrimary, CardActionSecondary as WCCardActionSecondary, CardActionTertiary as WCCardActionTertiary, CardBody as WCCardBody, CardDivider as WCCardDivider, CardFooter as WCCardFooter, CardSubtitle as WCCardSubtitle, CardTitle as WCCardTitle, Checkbox as WCCheckbox, Column as WCColumn, Container as WCContainer, Dialog as WCDialog, DialogActionPrimary as WCDialogActionPrimary, DialogActionSecondary as WCDialogActionSecondary, DialogActionTertiary as WCDialogActionTertiary, DialogActions as WCDialogActions, DialogBody as WCDialogBody, DialogClose as WCDialogClose, DialogFooter as WCDialogFooter, DialogHeader as WCDialogHeader, Divider as WCDivider, Drawer as WCDrawer, DrawerActionPrimary as WCDrawerActionPrimary, DrawerActionSecondary as WCDrawerActionSecondary, DrawerActionTertiary as WCDrawerActionTertiary, DrawerActions as WCDrawerActions, DrawerBody as WCDrawerBody, DrawerClose as WCDrawerClose, DrawerHeader as WCDrawerHeader, Dropdown as WCDropdown, DropdownItem as WCDropdownItem, DropdownMenu as WCDropdownMenu, DropdownTrigger as WCDropdownTrigger, EmptyState as WCEmptyState, EmptyStateAction as WCEmptyStateAction, EmptyStateHeader as WCEmptyStateHeader, EmptyStateIllustration as WCEmptyStateIllustration, EmptyStateMessage as WCEmptyStateMessage, Field as WCField, FieldHint as WCFieldHint, FieldLabel as WCFieldLabel, Grid as WCGrid, Group as WCGroup, Header as WCHeader, HeaderActions as WCHeaderActions, HeaderContent as WCHeaderContent, HeaderTitle as WCHeaderTitle, Icon as WCIcon, LabeledValue as WCLabeledValue, LabeledValueLabel as WCLabeledValueLabel, LabeledValueValue as WCLabeledValueValue, Link as WCLink, LogoLoader as WCLogoLoader, PageContent as WCPageContent, Pagination as WCPagination, ProgressBar as WCProgressBar, ProgressBarCountdown as WCProgressBarCountdown, Radio as WCRadio, RadioGroup as WCRadioGroup, Row as WCRow, Section as WCSection, SectionTitle as WCSectionTitle, Sidebar as WCSidebar, SpinnerWheel as WCSpinnerWheel, Stack as WCStack, Step as WCStep, Steps as WCSteps, SubHeader as WCSubHeader, Switch as WCSwitch, Switcher as WCSwitcher, Tab as WCTab, TabPanel as WCTabPanel, Table as WCTable, TableActions as WCTableActions, TableBody as WCTableBody, TableCell as WCTableCell, TableFeedback as WCTableFeedback, TableFoot as WCTableFoot, TableHead as WCTableHead, TableHeadCell as WCTableHeadCell, TableRow as WCTableRow, TableToolbar as WCTableToolbar, Tabs as WCTabs, Tag as WCTag, Text as WCText, TextArea as WCTextArea, TextField as WCTextField, Timeline as WCTimeline, TimelineExpandableItem as WCTimelineExpandableItem, TimelineItem as WCTimelineItem, TimelineItemBody as WCTimelineItemBody, TimelineItemFooter as WCTimelineItemFooter, TimelineItemHeader as WCTimelineItemHeader, TimelineItemHeaderSubtitle as WCTimelineItemHeaderSubtitle, TimelineItemHeaderTitle as WCTimelineItemHeaderTitle, TimelineItemIcon as WCTimelineItemIcon, Toggle as WCToggle, ToggleGroup as WCToggleGroup, Tooltip as WCTooltip } from '@loadsmart/miranda-wc';
import * as React from 'react';
import { forwardRef, useState, useCallback, useRef, useEffect } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var e = new Set(["children", "localName", "ref", "style", "className"]),
  n = new WeakMap(),
  t = function t(e, _t, o, l, a) {
    var s = a == null ? void 0 : a[_t];
    void 0 === s ? (e[_t] = o, null == o && _t in HTMLElement.prototype && e.removeAttribute(_t)) : o !== l && function (e, t, o) {
      var l = n.get(e);
      void 0 === l && n.set(e, l = new Map());
      var a = l.get(t);
      void 0 !== o ? void 0 === a ? (l.set(t, a = {
        handleEvent: o
      }), e.addEventListener(t, a)) : a.handleEvent = o : void 0 !== a && (l["delete"](t), e.removeEventListener(t, a));
    }(e, s, o);
  },
  o = function o(_ref) {
    var n = _ref.react,
      o = _ref.tagName,
      l = _ref.elementClass,
      a = _ref.events,
      s = _ref.displayName;
    var c = new Set(Object.keys(a != null ? a : {})),
      r = n.forwardRef(function (s, r) {
        var i = n.useRef(new Map()),
          d = n.useRef(null),
          f = {},
          u = {};
        for (var _i = 0, _Object$entries = Object.entries(s); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _Object$entries[_i],
            _n = _Object$entries$_i[0],
            _t2 = _Object$entries$_i[1];
          e.has(_n) ? f["className" === _n ? "class" : _n] = _t2 : c.has(_n) || _n in l.prototype ? u[_n] = _t2 : f[_n] = _t2;
        }
        return n.useLayoutEffect(function () {
          if (null === d.current) return;
          var e = new Map();
          for (var _n2 in u) t(d.current, _n2, s[_n2], i.current.get(_n2), a), i.current["delete"](_n2), e.set(_n2, s[_n2]);
          for (var _iterator = _createForOfIteratorHelperLoose(i.current), _step; !(_step = _iterator()).done;) {
            var _step$value = _step.value,
              _e = _step$value[0],
              _n3 = _step$value[1];
            t(d.current, _e, void 0, _n3, a);
          }
          i.current = e;
        }), n.useLayoutEffect(function () {
          var _d$current;
          (_d$current = d.current) == null || _d$current.removeAttribute("defer-hydration");
        }, []), f.suppressHydrationWarning = !0, n.createElement(o, _extends({}, f, {
          ref: n.useCallback(function (e) {
            d.current = e, "function" == typeof r ? r(e) : null !== r && (r.current = e);
          }, [r])
        }));
      });
    return r.displayName = s != null ? s : l.name, r;
  };

const createComponent = ({ subComponents, ...options }) => {
    const ReactComponent = o({
        react: React,
        ...options,
    });
    const ComponentWithSubComponents = ReactComponent;
    if (subComponents) {
        Object.assign(ComponentWithSubComponents, subComponents);
    }
    return ComponentWithSubComponents;
};

const WiredAccordionTitle = createComponent({
    tagName: 'm-accordion-title',
    elementClass: AccordionTitle$1,
    displayName: 'AccordionTitle',
});
const AccordionTitle = forwardRef((props, ref) => {
    const { leading, children, ...rest } = props;
    return (jsxs(WiredAccordionTitle, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const AccordionContent = createComponent({
    tagName: 'm-accordion-content',
    elementClass: AccordionContent$1,
    displayName: 'AccordionContent',
});

const Accordion = createComponent({
    tagName: 'm-accordion',
    elementClass: Accordion$1,
    displayName: 'Accordion',
    events: {
        onToggle: 'm-toggle',
    },
    subComponents: {
        Title: AccordionTitle,
        Content: AccordionContent,
    },
});

const Badge = createComponent({
    tagName: 'm-badge',
    elementClass: Badge$1,
    displayName: 'Badge',
});

const WiredBannerActionPrimary = createComponent({
    tagName: 'm-banner-action-primary',
    elementClass: BannerActionPrimary$1,
    displayName: 'BannerActionPrimary',
});
const BannerActionPrimary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredBannerActionPrimary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const BannerActions = createComponent({
    tagName: 'm-banner-actions',
    elementClass: BannerActions$1,
    displayName: 'BannerActions',
});

const WiredBannerActionSecondary = createComponent({
    tagName: 'm-banner-action-secondary',
    elementClass: BannerActionSecondary$1,
    displayName: 'BannerActionSecondary',
});
const BannerActionSecondary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredBannerActionSecondary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const BannerDescription = createComponent({
    tagName: 'm-banner-description',
    elementClass: BannerDescription$1,
    displayName: 'BannerDescription',
});

const BannerIcon = createComponent({
    tagName: 'm-banner-icon',
    elementClass: BannerIcon$1,
    displayName: 'BannerIcon',
});

const BannerTitle = createComponent({
    tagName: 'm-banner-title',
    elementClass: BannerTitle$1,
    displayName: 'BannerTitle',
});

const Banner = createComponent({
    tagName: 'm-banner',
    elementClass: Banner$1,
    events: {
        onDismiss: 'm-dismiss',
    },
    displayName: 'Banner',
    subComponents: {
        ActionPrimary: BannerActionPrimary,
        Actions: BannerActions,
        ActionSecondary: BannerActionSecondary,
        Description: BannerDescription,
        Icon: BannerIcon,
        Title: BannerTitle,
    },
});

const WiredButton = createComponent({
    tagName: 'm-button',
    elementClass: Button$1,
    displayName: 'Button',
});
const Button = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredButton, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredCardTitle = createComponent({
    tagName: 'm-card-title',
    elementClass: CardTitle$1,
    displayName: 'CardTitle',
});
const CardTitle = forwardRef(({ children, leading, ...props }, ref) => {
    return (jsxs(WiredCardTitle, { ...props, slot: "title", ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const CardSubtitle = createComponent({
    tagName: 'm-card-subtitle',
    elementClass: CardSubtitle$1,
    displayName: 'CardSubtitle',
});

const CardBody = createComponent({
    tagName: 'm-card-body',
    elementClass: CardBody$1,
    displayName: 'CardBody',
});

const CardDivider = createComponent({
    tagName: 'm-card-divider',
    elementClass: CardDivider$1,
    displayName: 'CardDivider',
});

const WiredCardActionPrimary = createComponent({
    tagName: 'm-card-action-primary',
    elementClass: CardActionPrimary$1,
    displayName: 'CardActionPrimary',
});
const CardActionPrimary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredCardActionPrimary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredCardActionSecondary = createComponent({
    tagName: 'm-card-action-secondary',
    elementClass: CardActionSecondary$1,
    displayName: 'CardActionSecondary',
});
const CardActionSecondary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredCardActionSecondary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredCardActionTertiary = createComponent({
    tagName: 'm-card-action-tertiary',
    elementClass: CardActionTertiary$1,
    displayName: 'CardActionTertiary',
});
const CardActionTertiary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredCardActionTertiary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const CardFooter = createComponent({
    tagName: 'm-card-footer',
    elementClass: CardFooter$1,
    displayName: 'CardFooter',
});

const Card = createComponent({
    tagName: 'm-card',
    elementClass: Card$1,
    displayName: 'Card',
    events: {
        onToggle: 'm-toggle',
    },
    subComponents: {
        Title: CardTitle,
        Subtitle: CardSubtitle,
        Body: CardBody,
        Divider: CardDivider,
        ActionPrimary: CardActionPrimary,
        ActionSecondary: CardActionSecondary,
        ActionTertiary: CardActionTertiary,
        Footer: CardFooter,
    },
});

const WiredCheckbox = createComponent({
    tagName: 'm-checkbox',
    elementClass: Checkbox$1,
    events: {
        onChange: 'm-change',
    },
    displayName: 'Checkbox',
});
const Checkbox = forwardRef((props, ref) => {
    const { children, leading, ...rest } = props;
    return (jsxs(WiredCheckbox, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const WiredDialogActionPrimary = createComponent({
    tagName: 'm-dialog-action-primary',
    elementClass: DialogActionPrimary$1,
    displayName: 'DialogActionPrimary',
});
const DialogActionPrimary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDialogActionPrimary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredDialogActionSecondary = createComponent({
    tagName: 'm-dialog-action-secondary',
    elementClass: DialogActionSecondary$1,
    displayName: 'DialogActionSecondary',
});
const DialogActionSecondary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDialogActionSecondary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredDialogActionTertiary = createComponent({
    tagName: 'm-dialog-action-tertiary',
    elementClass: DialogActionTertiary$1,
    displayName: 'DialogActionTertiary',
});
const DialogActionTertiary = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDialogActionTertiary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const DialogActions = createComponent({
    tagName: 'm-dialog-actions',
    elementClass: DialogActions$1,
    displayName: 'DialogActions',
});

const DialogBody = createComponent({
    tagName: 'm-dialog-body',
    elementClass: DialogBody$1,
    displayName: 'DialogBody',
});

const DialogClose = createComponent({
    tagName: 'm-dialog-close',
    elementClass: DialogClose$1,
    events: {
        onClose: 'm-close',
    },
    displayName: 'DialogClose',
});

const DialogFooter = createComponent({
    tagName: 'm-dialog-footer',
    elementClass: DialogFooter$1,
    displayName: 'DialogFooter',
});

const DialogHeader = createComponent({
    tagName: 'm-dialog-header',
    elementClass: DialogHeader$1,
    displayName: 'DialogHeader',
});

const Dialog = createComponent({
    tagName: 'm-dialog',
    elementClass: Dialog$1,
    events: {
        onClose: 'm-close',
        onOpening: 'm-opening',
        onOpened: 'm-opened',
        onClosing: 'm-closing',
        onClosed: 'm-closed',
    },
    displayName: 'Dialog',
    subComponents: {
        ActionPrimary: DialogActionPrimary,
        ActionSecondary: DialogActionSecondary,
        ActionTertiary: DialogActionTertiary,
        Actions: DialogActions,
        Body: DialogBody,
        Close: DialogClose,
        Footer: DialogFooter,
        Header: DialogHeader,
    },
});

const Divider = createComponent({
    tagName: 'm-divider',
    elementClass: Divider$1,
    displayName: 'Divider',
});

const WiredDrawerActionPrimary = createComponent({
    tagName: 'm-drawer-action-primary',
    elementClass: DrawerActionPrimary$1,
    displayName: 'DrawerActionPrimary',
});
const DrawerActionPrimary = forwardRef(function DrawerActionPrimary(props, ref) {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDrawerActionPrimary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredDrawerActionSecondary = createComponent({
    tagName: 'm-drawer-action-secondary',
    elementClass: DrawerActionSecondary$1,
    displayName: 'DrawerActionSecondary',
});
const DrawerActionSecondary = forwardRef(function DrawerActionSecondary(props, ref) {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDrawerActionSecondary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const WiredDrawerActionTertiary = createComponent({
    tagName: 'm-drawer-action-tertiary',
    elementClass: DrawerActionTertiary$1,
    displayName: 'DrawerActionTertiary',
});
const DrawerActionTertiary = forwardRef(function DrawerActionTertiary(props, ref) {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDrawerActionTertiary, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const DrawerActions = createComponent({
    tagName: 'm-drawer-actions',
    elementClass: DrawerActions$1,
    displayName: 'DrawerActions',
});

const DrawerBody = createComponent({
    tagName: 'm-drawer-body',
    elementClass: DrawerBody$1,
    displayName: 'DrawerBody',
});

const DrawerClose = createComponent({
    tagName: 'm-drawer-close',
    elementClass: DrawerClose$1,
    events: {
        onClose: 'm-close',
    },
    displayName: 'DrawerClose',
});

const DrawerHeader = createComponent({
    tagName: 'm-drawer-header',
    elementClass: DrawerHeader$1,
    displayName: 'DrawerHeader',
});

const Drawer = createComponent({
    tagName: 'm-drawer',
    elementClass: Drawer$1,
    events: {
        onClose: 'm-close',
        onOpening: 'm-opening',
        onOpened: 'm-opened',
        onClosing: 'm-closing',
        onClosed: 'm-closed',
    },
    displayName: 'Drawer',
    subComponents: {
        ActionPrimary: DrawerActionPrimary,
        ActionSecondary: DrawerActionSecondary,
        ActionTertiary: DrawerActionTertiary,
        Actions: DrawerActions,
        Body: DrawerBody,
        Close: DrawerClose,
        Header: DrawerHeader,
    },
});

const WiredDropdownItem = createComponent({
    tagName: 'm-dropdown-item',
    elementClass: DropdownItem$1,
    displayName: 'DropdownItem',
});
const DropdownItem = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredDropdownItem, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const DropdownMenu = createComponent({
    tagName: 'm-dropdown-menu',
    elementClass: DropdownMenu$1,
    displayName: 'DropdownMenu',
});

const WiredDropdownTrigger = createComponent({
    tagName: 'm-dropdown-trigger',
    elementClass: DropdownTrigger$1,
    displayName: 'DropdownTrigger',
});
const DropdownTrigger = forwardRef((props, ref) => {
    const { leading, children, ...rest } = props;
    return (jsxs(WiredDropdownTrigger, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const Dropdown = createComponent({
    tagName: 'm-dropdown',
    elementClass: Dropdown$1,
    displayName: 'Dropdown',
    subComponents: {
        Item: DropdownItem,
        Menu: DropdownMenu,
        Trigger: DropdownTrigger,
    },
    events: {
        onExpand: 'm-expand',
        onCollapse: 'm-collapse',
    },
});

const EmptyStateIllustration = createComponent({
    tagName: 'm-empty-state-illustration',
    elementClass: EmptyStateIllustration$1,
    displayName: 'EmptyStateIllustration',
});

const EmptyStateHeader = createComponent({
    tagName: 'm-empty-state-header',
    elementClass: EmptyStateHeader$1,
    displayName: 'EmptyStateHeader',
});

const EmptyStateMessage = createComponent({
    tagName: 'm-empty-state-message',
    elementClass: EmptyStateMessage$1,
    displayName: 'EmptyStateMessage',
});

const WiredEmptyStateAction = createComponent({
    tagName: 'm-empty-state-action',
    elementClass: EmptyStateAction$1,
    displayName: 'EmptyStateAction',
});
const EmptyStateAction = forwardRef((props, ref) => {
    const { leading, trailing, children, ...rest } = props;
    return (jsxs(WiredEmptyStateAction, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children, trailing != null && jsx("span", { slot: "trailing", children: trailing })] }));
});

const EmptyState = createComponent({
    tagName: 'm-empty-state',
    elementClass: EmptyState$1,
    events: {
        onAction: 'm-action',
    },
    displayName: 'EmptyState',
    subComponents: {
        Illustration: EmptyStateIllustration,
        Header: EmptyStateHeader,
        Message: EmptyStateMessage,
        Action: EmptyStateAction,
    },
});

const FieldLabel = createComponent({
    tagName: 'm-field-label',
    elementClass: FieldLabel$1,
    displayName: 'FieldLabel',
});

const WiredFieldHint = createComponent({
    tagName: 'm-field-hint',
    elementClass: FieldHint$1,
    displayName: 'FieldHint',
});
const FieldHint = forwardRef(({ children, leading, ...props }, ref) => {
    return (jsxs(WiredFieldHint, { ...props, slot: "hint", ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const Field = createComponent({
    tagName: 'm-field',
    elementClass: Field$1,
    displayName: 'Field',
    subComponents: {
        Label: FieldLabel,
        Hint: FieldHint,
    },
});

const HeaderActions = createComponent({
    tagName: 'm-header-actions',
    elementClass: HeaderActions$1,
    displayName: 'HeaderActions',
});

const HeaderContent = createComponent({
    tagName: 'm-header-content',
    elementClass: HeaderContent$1,
    displayName: 'HeaderContent',
});

const HeaderTitle = createComponent({
    tagName: 'm-header-title',
    elementClass: HeaderTitle$1,
    displayName: 'HeaderTitle',
});

const SubHeader = createComponent({
    tagName: 'm-sub-header',
    elementClass: SubHeader$1,
    displayName: 'SubHeader',
});

const HeaderBackButton = createComponent({
    tagName: 'm-back-button',
    elementClass: BackButton,
    displayName: 'HeaderBackButton',
});

const Header = createComponent({
    tagName: 'm-header',
    elementClass: Header$1,
    displayName: 'Header',
    subComponents: {
        Actions: HeaderActions,
        Content: HeaderContent,
        Title: HeaderTitle,
        SubHeader,
        BackButton: HeaderBackButton,
    },
});

const Icon = createComponent({
    tagName: 'm-icon',
    elementClass: Icon$1,
    displayName: 'Icon',
});

const LabeledValueLabel = createComponent({
    tagName: 'm-labeled-value-label',
    elementClass: LabeledValueLabel$1,
    displayName: 'LabeledValueLabel',
});
const LabeledValueValue = createComponent({
    tagName: 'm-labeled-value-value',
    elementClass: LabeledValueValue$1,
    displayName: 'LabeledValueValue',
});
const WiredLabeledValue = createComponent({
    tagName: 'm-labeled-value',
    elementClass: LabeledValue$1,
    displayName: 'LabeledValue',
    subComponents: {
        Label: LabeledValueLabel,
        Value: LabeledValueValue,
    },
});
const LabeledValue = Object.assign(forwardRef((props, ref) => {
    const { label, value, children, valueVariant, valueColor, labelVariant, labelColor, ...rest } = props;
    return (jsxs(WiredLabeledValue, { ...rest, ref: ref, children: [label != null && (jsx(LabeledValueLabel, { variant: labelVariant, color: labelColor, children: label })), value != null && (jsx(LabeledValueValue, { variant: valueVariant, color: valueColor, children: value })), children] }));
}), {
    Label: LabeledValueLabel,
    Value: LabeledValueValue,
});

const Box = createComponent({
    tagName: 'm-box',
    elementClass: Box$1,
    displayName: 'Box',
});

const Group = createComponent({
    tagName: 'm-group',
    elementClass: Group$1,
    displayName: 'Group',
});

const Stack = createComponent({
    tagName: 'm-stack',
    elementClass: Stack$1,
    displayName: 'Stack',
});

const Grid = createComponent({
    tagName: 'm-grid',
    elementClass: Grid$1,
    displayName: 'Grid',
});

const SidebarSide = forwardRef(({ children, ...boxProps }, ref) => {
    return (jsx(Box, { ...boxProps, slot: "sidebar", ref: ref, children: children }));
});
const SidebarContent = forwardRef(({ children, ...boxProps }, ref) => {
    return (jsx(Box, { ...boxProps, slot: "content", ref: ref, children: children }));
});
const Sidebar = createComponent({
    tagName: 'm-sidebar',
    elementClass: Sidebar$1,
    displayName: 'Sidebar',
    subComponents: {
        Side: SidebarSide,
        Content: SidebarContent,
    },
});

const Switcher = createComponent({
    tagName: 'm-switcher',
    elementClass: Switcher$1,
    displayName: 'Switcher',
});

const Container = createComponent({
    tagName: 'm-container',
    elementClass: Container$1,
    displayName: 'Container',
});
const Row = createComponent({
    tagName: 'm-row',
    elementClass: Row$1,
    displayName: 'Row',
});
const Column = createComponent({
    tagName: 'm-column',
    elementClass: Column$1,
    displayName: 'Column',
});

const Layout = () => {
    return null;
};
Layout.Box = Box;
Layout.Group = Group;
Layout.Stack = Stack;
Layout.Grid = Grid;
Layout.Sidebar = Sidebar;
Layout.Switcher = Switcher;
Layout.Container = Container;
Layout.Row = Row;
Layout.Column = Column;

const Link = createComponent({
    tagName: 'm-link',
    elementClass: Link$1,
    displayName: 'Link',
});

const Body = createComponent({
    tagName: 'm-body',
    elementClass: Body$1,
    displayName: 'Body',
});

const PageContent = createComponent({
    tagName: 'm-page-content',
    elementClass: PageContent$1,
    displayName: 'PageContent',
    subComponents: {
        Body,
    },
});

const Pagination = createComponent({
    tagName: 'm-pagination',
    elementClass: Pagination$1,
    displayName: 'Pagination',
    events: {
        onChange: 'm-change',
    },
});

const ProgressBar = createComponent({
    tagName: 'm-progress-bar',
    elementClass: ProgressBar$1,
    displayName: 'ProgressBar',
});

const ProgressBarCountdown = createComponent({
    tagName: 'm-progress-bar-countdown',
    elementClass: ProgressBarCountdown$1,
    displayName: 'ProgressBarCountdown',
});

const RadioGroup = createComponent({
    tagName: 'm-radio-group',
    elementClass: RadioGroup$1,
    events: {
        onChange: 'm-change',
    },
    displayName: 'RadioGroup',
});

const WiredRadio = createComponent({
    tagName: 'm-radio',
    elementClass: Radio$1,
    displayName: 'Radio',
});
const Radio = forwardRef((props, ref) => {
    const { children, leading, ...rest } = props;
    return (jsxs(WiredRadio, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const WiredSectionTitle = createComponent({
    tagName: 'm-section-title',
    elementClass: SectionTitle$1,
    displayName: 'SectionTitle',
});
const SectionTitle = forwardRef(({ children, leading, ...props }, ref) => {
    return (jsxs(WiredSectionTitle, { ...props, slot: "title", ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const Section = createComponent({
    tagName: 'm-section',
    elementClass: Section$1,
    displayName: 'Section',
    subComponents: {
        Title: SectionTitle,
    },
});

const SpinnerWheel = createComponent({
    tagName: 'm-spinner-wheel',
    elementClass: SpinnerWheel$1,
    displayName: 'SpinnerWheel',
});

const Step = createComponent({
    tagName: 'm-step',
    elementClass: Step$1,
    displayName: 'Step',
});

const Steps = createComponent({
    tagName: 'm-steps',
    elementClass: Steps$1,
    displayName: 'Steps',
    events: {
        onChange: 'm-change',
        onComplete: 'm-complete',
        onNavigate: 'm-navigate',
        onNext: 'm-next',
        onPrevious: 'm-previous',
    },
    subComponents: {
        Step,
    },
});

function createCustomEvent(eventName, detail) {
    const event = new CustomEvent(eventName, {
        bubbles: true,
        detail,
    });
    return event;
}
function useSteps() {
    const [stepsElement, setStepsElement] = useState(null);
    const registerSteps = useCallback(() => {
        return {
            ref(element) {
                if (element == null || stepsElement != null) {
                    return;
                }
                setStepsElement(element);
            },
        };
    }, [stepsElement]);
    const navigateToStep = useCallback(
    /**
     * Either `'previous'`, `'next'`, or step name.
     */
    (step) => {
        if (stepsElement == null) {
            return;
        }
        const navigateToNextStep = () => {
            return createCustomEvent('m-next');
        };
        const navigateToPreviousStep = () => {
            return createCustomEvent('m-previous');
        };
        let event;
        switch (step) {
            case 'next':
                event = navigateToNextStep();
                break;
            case 'previous':
                event = navigateToPreviousStep();
                break;
            default:
                event = createCustomEvent('m-navigate', step);
        }
        stepsElement.dispatchEvent(event);
    }, [stepsElement]);
    const completeStep = useCallback(() => {
        if (stepsElement == null) {
            return;
        }
        const event = createCustomEvent('m-complete');
        stepsElement.dispatchEvent(event);
    }, [stepsElement]);
    return {
        elementRef: stepsElement,
        registerSteps,
        navigateToStep,
        completeStep,
    };
}

const Switch = createComponent({
    tagName: 'm-switch',
    elementClass: Switch$1,
    displayName: 'Switch',
    events: {
        onChange: 'm-change',
    },
});

const TableHead = createComponent({
    tagName: 'm-table-head',
    elementClass: TableHead$1,
    displayName: 'TableHead',
});

const TableBody = createComponent({
    tagName: 'm-table-body',
    elementClass: TableBody$1,
    displayName: 'TableBody',
});

const TableFoot = createComponent({
    tagName: 'm-table-foot',
    elementClass: TableFoot$1,
    displayName: 'TableFoot',
});

const TableRow = createComponent({
    tagName: 'm-table-row',
    elementClass: TableRow$1,
    displayName: 'TableRow',
});

const TableCell = createComponent({
    tagName: 'm-table-cell',
    elementClass: TableCell$1,
    displayName: 'TableCell',
});

const TableToolbar = createComponent({
    tagName: 'm-table-toolbar',
    elementClass: TableToolbar$1,
    displayName: 'TableToolbar',
});

const TableHeadCell = createComponent({
    tagName: 'm-table-head-cell',
    elementClass: TableHeadCell$1,
    displayName: 'TableHeadCell',
    events: {
        onSort: 'm-sort',
    },
});

const TableFeedback = createComponent({
    tagName: 'm-table-feedback',
    elementClass: TableFeedback$1,
    displayName: 'TableFeedback',
});

const TableActions = createComponent({
    tagName: 'm-table-actions',
    elementClass: TableActions$1,
    displayName: 'TableActions',
});

const Table = createComponent({
    tagName: 'm-table',
    elementClass: Table$1,
    displayName: 'Table',
    subComponents: {
        Head: TableHead,
        Body: TableBody,
        Foot: TableFoot,
        Row: TableRow,
        HeadCell: TableHeadCell,
        Cell: TableCell,
        Toolbar: TableToolbar,
        Feedback: TableFeedback,
        Actions: TableActions,
    },
});

const WiredTab = createComponent({
    tagName: 'm-tab',
    elementClass: Tab$1,
    displayName: 'Tab',
});
const Tab = forwardRef(({ children, leading, ...props }, ref) => {
    return (jsxs(WiredTab, { ...props, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const TabPanel = createComponent({
    tagName: 'm-tab-panel',
    elementClass: TabPanel$1,
    displayName: 'TabPanel',
});

const Tabs = createComponent({
    tagName: 'm-tabs',
    elementClass: Tabs$1,
    events: {
        onTabChange: 'm-tab-change',
    },
    displayName: 'Tabs',
    subComponents: {
        Tab,
        Panel: TabPanel,
    },
});

const WiredTag = createComponent({
    tagName: 'm-tag',
    elementClass: Tag$1,
    displayName: 'Tag',
});
const Tag = forwardRef((props, ref) => {
    const { leading, children, ...rest } = props;
    return (jsxs(WiredTag, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const WiredActionableTag = createComponent({
    tagName: 'm-actionable-tag',
    elementClass: ActionableTag$1,
    displayName: 'ActionableTag',
    events: {
        onChange: 'm-change',
        onRemove: 'm-remove',
    },
});
const ActionableTag = forwardRef((props, ref) => {
    const { leading, children, selectable, removable, ...rest } = props;
    return (jsxs(WiredActionableTag, { ...rest, selectable: selectable || Boolean(rest.onChange), removable: removable || Boolean(rest.onRemove), ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const Text = createComponent({
    tagName: 'm-text',
    elementClass: Text$1,
    displayName: 'Text',
});

const WiredTextArea = createComponent({
    tagName: 'm-text-area',
    elementClass: TextArea$1,
    events: {
        onInput: 'input',
        onChange: 'change',
    },
    displayName: 'TextArea',
});
function TextArea(props) {
    return jsx(WiredTextArea, { ...props });
}

const WiredTextField = createComponent({
    tagName: 'm-text-field',
    elementClass: TextField$1,
    events: {
        onInput: 'input',
        onChange: 'change',
        onClear: 'm-clear',
    },
    displayName: 'TextField',
});
const TextField = forwardRef(({ leading, trailing, ...rest }, ref) => {
    return (jsxs(WiredTextField, { ...rest, ref: ref, children: [leading != null && jsx("div", { slot: "leading", children: leading }), trailing != null && jsx("div", { slot: "trailing", children: trailing })] }));
});

const TimelineItem = createComponent({
    tagName: 'm-timeline-item',
    elementClass: TimelineItem$1,
    displayName: 'TimelineItem',
});

const TimelineExpandableItem = createComponent({
    tagName: 'm-timeline-expandable-item',
    elementClass: TimelineExpandableItem$1,
    displayName: 'TimelineExpandableItem',
});

const TimelineItemBody = createComponent({
    tagName: 'm-timeline-item-body',
    elementClass: TimelineItemBody$1,
    displayName: 'TimelineItemBody',
});

const TimelineItemFooter = createComponent({
    tagName: 'm-timeline-item-footer',
    elementClass: TimelineItemFooter$1,
    displayName: 'TimelineItemFooter',
});

const TimelineItemHeader = createComponent({
    tagName: 'm-timeline-item-header',
    elementClass: TimelineItemHeader$1,
    displayName: 'TimelineItemHeader',
});

const TimelineItemHeaderSubtitle = createComponent({
    tagName: 'm-timeline-item-header-subtitle',
    elementClass: TimelineItemHeaderSubtitle$1,
    displayName: 'TimelineItemHeaderSubtitle',
});

const TimelineItemHeaderTitle = createComponent({
    tagName: 'm-timeline-item-header-title',
    elementClass: TimelineItemHeaderTitle$1,
    displayName: 'TimelineItemHeaderTitle',
});

const TimelineItemIcon = createComponent({
    tagName: 'm-timeline-item-icon',
    elementClass: TimelineItemIcon$1,
    displayName: 'TimelineItemIcon',
});

const Timeline = createComponent({
    tagName: 'm-timeline',
    elementClass: Timeline$1,
    displayName: 'Timeline',
    subComponents: {
        Item: TimelineItem,
        ExpandableItem: TimelineExpandableItem,
        ItemBody: TimelineItemBody,
        ItemFooter: TimelineItemFooter,
        ItemHeader: TimelineItemHeader,
        ItemHeaderTitle: TimelineItemHeaderTitle,
        ItemHeaderSubtitle: TimelineItemHeaderSubtitle,
        ItemIcon: TimelineItemIcon,
    },
});

const WiredToggle = createComponent({
    tagName: 'm-toggle',
    elementClass: Toggle$1,
    displayName: 'Toggle',
});
const Toggle = forwardRef((props, ref) => {
    const { children, leading, ...rest } = props;
    return (jsxs(WiredToggle, { ...rest, ref: ref, children: [leading != null && jsx("span", { slot: "leading", children: leading }), children] }));
});

const WiredToggleGroup = createComponent({
    tagName: 'm-toggle-group',
    elementClass: ToggleGroup$1,
    events: {
        onChange: 'm-change',
    },
    displayName: 'ToggleGroup',
});
function ToggleGroup(props) {
    const { value, options, children, disabled, ...rest } = props;
    const ref = useRef(null);
    useEffect(
    /**
     * we use a `ref` to update the `value` attribute whenever the `value` prop
     * changes. As the m-toggle-group accepts `string | string[]` and arrays
     * cannot be passed as regular attributes, setting the value via reference
     * seemed a convenient way to do that without needing any parsing or serialization.
     */
    function onValueChange() {
        if (ref.current == null) {
            return;
        }
        ref.current.value = value;
    }, [value]);
    return (jsx(WiredToggleGroup, { ref: ref, disabled: disabled, ...rest, children: children ??
            (options || []).map(function renderOption(option) {
                const { label, value: optionValue, ...others } = option;
                return (jsx(Toggle, { ...others, disabled: Boolean(disabled || option.disabled), value: optionValue, children: label }, optionValue));
            }) }));
}

const WiredTooltip = createComponent({
    tagName: 'm-tooltip',
    elementClass: Tooltip$1,
    displayName: 'Tooltip',
});
const FLOATING_STYLE = {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
};
function Tooltip(props) {
    const { children, message, trigger, ...rest } = props;
    const ref = useRef(null);
    useEffect(function onTriggerChange() {
        if (ref.current == null || trigger == null) {
            return;
        }
        ref.current.trigger = Array.isArray(trigger) ? trigger : [trigger];
    }, [trigger]);
    return (jsxs(WiredTooltip, { ref: ref, ...rest, children: [jsx(Box, { slot: "floating", padding: "none", children: message }), jsx("span", { slot: "reference", style: FLOATING_STYLE, children: children })] }));
}

const LogoLoader = createComponent({
    tagName: 'm-logo-loader',
    elementClass: LogoLoader$1,
    displayName: 'LogoLoader',
});

const DotsLoader = createComponent({
    tagName: 'm-dots-loader',
    elementClass: DotsLoader$1,
    displayName: 'DotsLoader',
});

export { Accordion, ActionableTag, Badge, Banner, Box, Button, Card, Checkbox, Column, Container, Dialog, Divider, DotsLoader, Drawer, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, EmptyState, Field, Grid, Group, Header, HeaderActions, HeaderTitle, Icon, LabeledValue, LabeledValueLabel, LabeledValueValue, Layout, Link, LogoLoader, PageContent, Pagination, ProgressBar, ProgressBarCountdown, Radio, RadioGroup, Row, Section, Sidebar, SpinnerWheel, Stack, Step, Steps, SubHeader, Switch, Switcher, Tab, TabPanel, Table, TableActions, TableBody, TableCell, TableFeedback, TableFoot, TableHead, TableHeadCell, TableRow, TableToolbar, Tabs, Tag, Text, TextArea, TextField, Timeline, TimelineExpandableItem, TimelineItem, TimelineItemBody, TimelineItemFooter, TimelineItemHeader, TimelineItemHeaderSubtitle, TimelineItemHeaderTitle, TimelineItemIcon, Toggle, ToggleGroup, Tooltip, useSteps };
